export default __webpack_public_path__ + "static/lifecycle_management-a01b8ff422955c7712fbf011dab52778.svg";